import React from 'react';

import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';

import { StyledTimelineItem } from '../ui/styled-timeline';

export const AutomationTimelineTitle = ({
  isFirst,
  isLast,
  title,
  icon,
}: {
  isFirst?: boolean;
  isLast?: boolean;
  title?: string | React.ReactNode;
  icon?: React.ReactNode;
}) => (
  <StyledTimelineItem>
    <div className="u-flex-center">
      <TimelineSeparator>
        {(!(isFirst || isLast) || (isLast && title)) && (
          <TimelineConnector style={{ marginLeft: '-1px' }} />
        )}
        {icon ? (
          <TimelineDot variant="outlined" className="u-padding-none" style={{ marginLeft: '-1px' }}>
            {icon}
          </TimelineDot>
        ) : (
          <TimelineDot variant="outlined" />
        )}
        {!isLast && <TimelineConnector style={{ marginLeft: '-1px' }} />}
      </TimelineSeparator>
      {title && <TimelineContent className="typo-title">{title}</TimelineContent>}
    </div>
  </StyledTimelineItem>
);
